module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-menu"
  }, [_c('b-dropdown', {
    attrs: {
      "id": "user-menu",
      "text": _vm.me.name,
      "variant": "outline-info",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.handleLogout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out-alt"
  }), _vm._v(" Uitloggen\n\t\t")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a4da786"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/UserMenu.vue
// module id = 1323
// module chunks = 1